module.exports = __webpack_public_path__ + "img/T5-A-xs_03.d65ad5f3.png";